/* eslint-enable */
/* eslint-enable */

class AnimationLandVideoPopup {
	
	constructor(args = { sectionsContainer: document }) {
		this.sectionsContainer = args.sectionsContainer;
		this.$landVideoPopup = this.sectionsContainer.querySelectorAll('.land-video-popup');
		console.log(this.$landVideoPopup)
		if (!this.$landVideoPopup)
			return;
		
		this.$landVideoPopupElements = [];
		this.$landVideoPopup.forEach(module => {
			this.$landVideoPopupElements.push(module.querySelectorAll('.anima'));	
		});
		
		this.init();
	}

	/* eslint-disable class-methods-use-this, no-unused-vars */
	init() {
		this.setAnimation();
	}

	setAnimation() {
		this.$landVideoPopup.forEach((modile, index) => {
			gsap.set(module, { opacity: 1});
	        gsap.set(this.$landVideoPopupElements[index], { yPercent: 20, opacity: 0, onComplete: () => {
				this.initAnimate(index);
			} });	
		});
	}

	initAnimate(index) {
		const landVideoPopup = gsap.timeline({
			defaults: { duration: 1.2, ease: 'power4.out' },
            scrollTrigger: {
                trigger: this.$landVideoPopup[index],
				start: '-20% 50%'
				//start: 'top 100%'
			},
			onComplete: () => {
				gsap.set(this.$landVideoPopupElements[index], { clearProps: true });
			}
        });
    
        landVideoPopup.addLabel('step1');
        landVideoPopup.to(this.$landVideoPopup[index], { opacity: 1, duration: 1 }, 'step1');
		landVideoPopup.to(this.$landVideoPopupElements[index], { yPercent: 0, opacity: 1, stagger: 0.2 }, 'step1+=0.3');
	}
	/* eslint-enable class-methods-use-this, no-unused-vars */
}
export default AnimationLandVideoPopup;